"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SettingsVideoInput = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _useBackgroundFilterPageActionsApi = require("@studio/metrics/client/react/useBackgroundFilterPageActionsApi");
var _utils = require("../utils");
var _VirtualBackground = require("@studio/constants/VirtualBackground");
var _DeviceTypes = require("@studio/constants/DeviceTypes");
var _underscore = require("underscore");
var _FormDropdown = require("../../FormDropdown/FormDropdown");
var _Switch = require("../../Switch/Switch");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _useCommonPageActionsApi = require("@studio/metrics/client/react/useCommonPageActionsApi");
var _useAudioVideoDevice = require("@studio/chime/hooks/useAudioVideoDevice");
var _getVideoInput = require("@studio/chime/backgroundFilters/getVideoInput");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); }
var SettingsVideoInput = exports.SettingsVideoInput = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var meetingSession = _ref.meetingSession,
    showBlurredBackgroundSwitch = _ref.showBlurredBackgroundSwitch,
    userBackground = _ref.userBackground,
    onVideoInputChange = _ref.onVideoInputChange,
    setUserBackground = _ref.setUserBackground,
    transformedVideoInput = _ref.transformedVideoInput,
    selectedVideoInputId = _ref.selectedVideoInputId,
    onTransformedVideoInputChange = _ref.onTransformedVideoInputChange,
    isAudioPermissionDenied = _ref.isAudioPermissionDenied,
    backgroundUrl = _ref.backgroundUrl,
    _ref$setIsVideoChangi = _ref.setIsVideoChanging,
    setIsVideoChanging = _ref$setIsVideoChangi === void 0 ? function () {} : _ref$setIsVideoChangi,
    _ref$setIsVideoDiscon = _ref.setIsVideoDisconnected,
    setIsVideoDisconnected = _ref$setIsVideoDiscon === void 0 ? function () {} : _ref$setIsVideoDiscon;
  var _useBackgroundFilterP = (0, _useBackgroundFilterPageActionsApi.useBackgroundFilterPageActionsApi)(),
    startAttendeeBackgroundFilterChangeLatency = _useBackgroundFilterP.startAttendeeBackgroundFilterChangeLatency,
    endAttendeeBackgroundFilterChangeLatency = _useBackgroundFilterP.endAttendeeBackgroundFilterChangeLatency;
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    videoDevices = _useState2[0],
    setVideoDevices = _useState2[1];
  (0, _useAudioVideoDevice.useAudioVideoDevice)({
    meetingSession: meetingSession,
    setDevices: setVideoDevices,
    onDeviceChanged: onVideoInputChange,
    selectedDeviceId: selectedVideoInputId,
    deviceType: _DeviceTypes.VIDEO_INPUT,
    transformedVideoInput: transformedVideoInput
  });
  var _useCommonPageActions = (0, _useCommonPageActionsApi.useCommonPageActionsApi)(),
    cameraChanged = _useCommonPageActions.cameraChanged;
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isLoadingVirtualBackground = _useState4[0],
    setIsLoadingVirtualBackground = _useState4[1];
  var disableVideoInput = (videoDevices === null || videoDevices === void 0 ? void 0 : videoDevices.length) === 1 && videoDevices[0].value === '' || isLoadingVirtualBackground || isAudioPermissionDenied;
  var formattedVideoDevices = (0, _utils.formatDevicesArrayForDropdown)(videoDevices);
  var handleVideoInputChange = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(videoInputId, videoInputName) {
      var videoInput, _t;
      return _regenerator["default"].wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(videoInputId === selectedVideoInputId || !selectedVideoInputId)) {
              _context.next = 1;
              break;
            }
            return _context.abrupt("return");
          case 1:
            _context.prev = 1;
            setIsVideoChanging(true);
            if (userBackground !== _VirtualBackground.BACKGROUND_OPTIONS.NONE) {
              startAttendeeBackgroundFilterChangeLatency({
                filterTypeBefore: userBackground,
                filterTypeAfter: userBackground
              });
            }
            setIsLoadingVirtualBackground(true);
            _context.next = 2;
            return (0, _getVideoInput.getVideoInput)(userBackground, transformedVideoInput, videoInputId, onTransformedVideoInputChange, userBackground === _VirtualBackground.BACKGROUND_OPTIONS.CUSTOM ? backgroundUrl : '');
          case 2:
            videoInput = _context.sent;
            onVideoInputChange(videoInput);
            cameraChanged({
              cameraName: videoInputName
            });
            if (userBackground !== _VirtualBackground.BACKGROUND_OPTIONS.NONE) {
              endAttendeeBackgroundFilterChangeLatency();
            }
            _context.next = 4;
            break;
          case 3:
            _context.prev = 3;
            _t = _context["catch"](1);
            console.error('Error changing video input', _t);
            endAttendeeBackgroundFilterChangeLatency({
              error: "Error changing video input : ".concat(_t.message)
            });
          case 4:
            _context.prev = 4;
            setIsLoadingVirtualBackground(false);
            return _context.finish(4);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 3, 4, 5]]);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [selectedVideoInputId, userBackground, transformedVideoInput, onTransformedVideoInputChange, backgroundUrl]);
  var handleBlurBackgroundChange = (0, _react.useCallback)((0, _underscore.debounce)(/*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(event) {
      var checked, option, videoInput, _t2;
      return _regenerator["default"].wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            checked = event.target.checked;
            option = checked ? _VirtualBackground.BACKGROUND_OPTIONS.NONE : _VirtualBackground.BACKGROUND_OPTIONS.BLUR;
            _context2.prev = 1;
            setIsVideoChanging(true);
            startAttendeeBackgroundFilterChangeLatency({
              filterTypeBefore: userBackground,
              filterTypeAfter: option
            });
            setIsLoadingVirtualBackground(true);
            _context2.next = 2;
            return (0, _getVideoInput.getVideoInput)(option, transformedVideoInput, selectedVideoInputId, onTransformedVideoInputChange);
          case 2:
            videoInput = _context2.sent;
            onVideoInputChange(videoInput);
            setUserBackground(option);
            setIsLoadingVirtualBackground(false);
            endAttendeeBackgroundFilterChangeLatency();
            _context2.next = 4;
            break;
          case 3:
            _context2.prev = 3;
            _t2 = _context2["catch"](1);
            console.error('Error changing background option', _t2);
            endAttendeeBackgroundFilterChangeLatency({
              error: "Error changing background option : ".concat(_t2.message)
            });
          case 4:
            _context2.prev = 4;
            setIsLoadingVirtualBackground(false);
            return _context2.finish(4);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 3, 4, 5]]);
    }));
    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }(), 500), [selectedVideoInputId, transformedVideoInput, onTransformedVideoInputChange]);

  // Handles fallback to default when USB or Bluetooth device disconnects PROD-222661
  (0, _react.useEffect)(function () {
    if (videoDevices.length === 0) {
      onVideoInputChange(null);
      return;
    }
    var deviceConnected = videoDevices.some(function (option) {
      return option.deviceId === selectedVideoInputId;
    });
    if (!deviceConnected) {
      setIsVideoDisconnected(true);
      handleVideoInputChange(videoDevices[0].deviceId, videoDevices[0].label);
    }
  }, [handleVideoInputChange, selectedVideoInputId, videoDevices]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_FormDropdown.FormDropdown, {
    labelText: "Select Camera",
    "data-testid": "selectCamera",
    selected: selectedVideoInputId,
    options: formattedVideoDevices,
    id: "selectCamera",
    onChange: handleVideoInputChange,
    disabled: disableVideoInput,
    className: "mb-0"
  }), showBlurredBackgroundSwitch && /*#__PURE__*/_react["default"].createElement(_Switch.Switch, {
    className: "pt-1",
    labelText: "Blur background",
    id: "blurBackground",
    "data-testid": "blurBackground",
    disabled: disableVideoInput,
    checked: userBackground === _VirtualBackground.BACKGROUND_OPTIONS.BLUR,
    "data-dd-action-name": "Background option switched to ".concat(userBackground === _VirtualBackground.BACKGROUND_OPTIONS.BLUR ? _VirtualBackground.BACKGROUND_OPTIONS.NONE : _VirtualBackground.BACKGROUND_OPTIONS.BLUR),
    onChange: handleBlurBackgroundChange
  }));
});
SettingsVideoInput.propTypes = {
  meetingSession: _propTypes["default"].object,
  showBlurredBackgroundSwitch: _propTypes["default"].bool,
  userBackground: _propTypes["default"].string,
  onVideoInputChange: _propTypes["default"].func,
  setUserBackground: _propTypes["default"].func,
  transformedVideoInput: _propTypes["default"].object,
  selectedVideoInputId: _propTypes["default"].string,
  onTransformedVideoInputChange: _propTypes["default"].func,
  isAudioPermissionDenied: _propTypes["default"].bool,
  backgroundUrl: _propTypes["default"].string,
  setIsVideoChanging: _propTypes["default"].func,
  setIsVideoDisconnected: _propTypes["default"].func
};